export default {
  setFileUpload() {
    // alert('File mutations!');
    // state.fileUpload = value;
  },
};
